import { FC } from 'react'

export const ErrorMessage: FC<{ errorMessage: string }> = ({ errorMessage }) => {
  return <p className={'text-xs mt-2 text-error-500'}>{errorMessage}</p>
}
